import { login, getUserInfo } from '@/api/sys'
import md5 from 'md5'
import { setItem, getItem, removeAllItem } from '@/utils/storage'
import { setTimeStamp } from '@/utils/auth'
import { TOKEN } from '@/constant/index'
import router, { resetRouter } from '@/router'

export default {
  namespaced: true,
  state: () => ({
    token: getItem(TOKEN) || '',
    userInfo: {}
  }),
  // 异步操作
  actions: {
    async login(context, userInfo) {
      const { username, password } = userInfo
      const response = await login({ username, password: md5(password) })
      const { token } = response
      context.commit('SET_TOKEN', token)
      setTimeStamp() // 记录登录的时间
      return response
    },
    async getUserInfo(context) {
      const response = await getUserInfo()
      context.commit('SET_USER_INFO', response)
      return response
    },
    logout(context) {
      resetRouter()
      context.commit('SET_TOKEN', '')
      context.commit('SET_USER_INFO', {})
      removeAllItem()
      router.push('/login')
    }

  },
  // 同步操作
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      setItem(TOKEN, token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    }
  }
}
